import React from "react";
import { Button } from "react-bootstrap";

function ShowMoreButton({ shownRows, total, eventHandler }) {
    return shownRows < total ? (
        <div className="tw-flex tw-items-center tw-justify-center tw-mt-6">
            <Button
                className="tw-bg-transparent tw-text-white tw-rounded-[10px] tw-cursor-pointer tw-border-3 tw-border-solid tw-border-white tw-py-3 tw-px-10"
                onClick={eventHandler}
            >
                Load more jobs
            </Button>
        </div>
    ) : null;
}

export default ShowMoreButton;